import { j as e } from "./atoms-v218.js";
import { Wrapper as P, Header as k, MainTitleSection as p, MainTitleText as u, MainTitlePrice as w, SectionWithDueLater as A, ItemInHeader as L, ItemInHeaderText as $, ItemInHeaderPrice as y, PriceBreakdown as B, AlignedLink as g, PriceBreakdownSection as j, PriceBreakdownItem as i, PriceBreakdownItemText as h, PriceBreakdownItemPrice as s, TotalPriceLabel as S, CancellationPolicySection as b, CancellationPolicyTitle as I, CancellationPolicyText as C } from "./atoms-v21038.js";
import { useState as f } from "react";
import { Link as H } from "./atoms-v224.js";
import { Text as N } from "./atoms-v243.js";
const D = (t) => {
  const {
    colorTheme: r = "light",
    currency: c,
    dueLaterAmount: a,
    dueNowAmount: m,
    language: n,
    priceBreakdown: l,
    setIsPriceBreakdownOpen: x,
    translations: o
  } = t, d = a ?? 0;
  return /* @__PURE__ */ e.jsxs(k, { $colorTheme: r, $hasDueLater: !!a, children: [
    /* @__PURE__ */ e.jsxs(p, { children: [
      /* @__PURE__ */ e.jsx(u, { $colorTheme: r, children: a ? o.totalLabel.toUpperCase() : o.dueNowLabel.toUpperCase() }),
      /* @__PURE__ */ e.jsx(w, { $colorTheme: r, children: l.totalAmount.toLocaleString(n, {
        currency: c,
        style: "currency"
      }) })
    ] }),
    d > 0 && /* @__PURE__ */ e.jsxs(A, { children: [
      /* @__PURE__ */ e.jsxs(L, { $colorTheme: r, children: [
        /* @__PURE__ */ e.jsx($, { $colorTheme: r, children: o.dueNowLabel }),
        /* @__PURE__ */ e.jsx(y, { $colorTheme: r, children: m.toLocaleString(n, {
          currency: c,
          style: "currency"
        }) })
      ] }),
      /* @__PURE__ */ e.jsxs(L, { $colorTheme: r, children: [
        /* @__PURE__ */ e.jsx($, { $colorTheme: r, children: o.dueLaterLabel }),
        /* @__PURE__ */ e.jsx(y, { $colorTheme: r, children: d.toLocaleString(n, {
          currency: c,
          style: "currency"
        }) })
      ] })
    ] }),
    /* @__PURE__ */ e.jsx(H, { renderAsButton: !0, onClick: () => x(!0), children: /* @__PURE__ */ e.jsx(u, { $colorTheme: r, children: o.showPriceBreakdownLink }) })
  ] });
}, O = (t) => {
  const {
    colorTheme: r = "light",
    currency: c,
    dueLaterAmount: a,
    dueNowAmount: m,
    language: n,
    priceBreakdown: l,
    setIsPriceBreakdownOpen: x,
    translations: o
  } = t, d = l.totalAddonPrice ?? 0, T = a ?? 0;
  return /* @__PURE__ */ e.jsxs(B, { $colorTheme: r, children: [
    /* @__PURE__ */ e.jsx(g, { renderAsButton: !0, onClick: () => x(!1), children: /* @__PURE__ */ e.jsx(u, { $colorTheme: r, children: o.hidePriceBreakdownLink }) }),
    /* @__PURE__ */ e.jsxs(j, { $colorTheme: r, children: [
      /* @__PURE__ */ e.jsxs(N, { type: "heading", variant: "compact-01", children: [
        o.roomLabel,
        ": ",
        l.roomName
      ] }),
      /* @__PURE__ */ e.jsxs(i, { children: [
        /* @__PURE__ */ e.jsx(h, { $colorTheme: r, children: o.roomTotalLabel }),
        /* @__PURE__ */ e.jsx(s, { $colorTheme: r, children: l.roomTotalAmountBeforeTaxes.toLocaleString(n, {
          currency: c,
          style: "currency"
        }) })
      ] }),
      d > 0 && /* @__PURE__ */ e.jsxs(i, { children: [
        /* @__PURE__ */ e.jsx(h, { $colorTheme: r, children: o.addonsLabel }),
        /* @__PURE__ */ e.jsx(s, { $colorTheme: r, children: d.toLocaleString(n, {
          currency: c,
          style: "currency"
        }) })
      ] }),
      /* @__PURE__ */ e.jsxs(i, { children: [
        /* @__PURE__ */ e.jsx(h, { $colorTheme: r, children: o.taxesAndFeesLabel }),
        /* @__PURE__ */ e.jsx(s, { $colorTheme: r, children: l.taxesAndFeesAmount.toLocaleString(n, {
          currency: c,
          style: "currency"
        }) })
      ] })
    ] }),
    T > 0 && /* @__PURE__ */ e.jsxs(j, { $colorTheme: r, children: [
      /* @__PURE__ */ e.jsxs(i, { children: [
        /* @__PURE__ */ e.jsx(h, { $colorTheme: r, children: o.dueNowLabel }),
        /* @__PURE__ */ e.jsx(s, { $colorTheme: r, children: m.toLocaleString(n, {
          currency: c,
          style: "currency"
        }) })
      ] }),
      /* @__PURE__ */ e.jsxs(i, { children: [
        /* @__PURE__ */ e.jsx(h, { $colorTheme: r, children: o.dueLaterLabel }),
        /* @__PURE__ */ e.jsx(s, { $colorTheme: r, children: T.toLocaleString(n, {
          currency: c,
          style: "currency"
        }) })
      ] })
    ] }),
    /* @__PURE__ */ e.jsx(j, { $colorTheme: r, children: /* @__PURE__ */ e.jsxs(i, { children: [
      /* @__PURE__ */ e.jsx(S, { $colorTheme: r, children: o.totalPriceLabel }),
      /* @__PURE__ */ e.jsx(s, { $colorTheme: r, children: l.totalAmount.toLocaleString(n, {
        currency: c,
        style: "currency"
      }) })
    ] }) }),
    /* @__PURE__ */ e.jsxs(b, { children: [
      /* @__PURE__ */ e.jsx(I, { $colorTheme: r, children: o.paymentAndCancellationPolicyTitle }),
      /* @__PURE__ */ e.jsx(C, { $colorTheme: r, children: l.paymentAndCancellationPolicy })
    ] })
  ] });
}, E = (t) => {
  const [r, c] = f(!1);
  return /* @__PURE__ */ e.jsx(P, { children: r ? /* @__PURE__ */ e.jsx(O, { ...t, setIsPriceBreakdownOpen: c }) : /* @__PURE__ */ e.jsx(D, { ...t, setIsPriceBreakdownOpen: c }) });
};
export {
  E as PaymentHeader
};
